export const COUNTRIES = [
  { code: 'HR', name: 'Hrvatska', flag: '🇭🇷' },
  { code: 'RS', name: 'Srbija', flag: '🇷🇸' },
  { code: 'BA', name: 'Bosna i Hercegovina', flag: '🇧🇦' }
];

export const CITIES = {
  HR: [
    'Zagreb', 'Split', 'Rijeka', 'Osijek', 'Zadar', 'Slavonski Brod', 'Pula', 'Karlovac', 
    'Sisak', 'Varaždin', 'Šibenik', 'Dubrovnik', 'Bjelovar', 'Koprivnica', 'Požega', 
    'Virovitica', 'Gospić', 'Pazin', 'Čakovec', 'Petrinja'
  ],
  RS: [
    'Beograd', 'Novi Sad', 'Niš', 'Kragujevac', 'Subotica', 'Zrenjanin', 'Pančevo', 
    'Čačak', 'Novi Pazar', 'Kraljevo', 'Leskovac', 'Smederevo', 'Valjevo', 'Vranje', 
    'Šabac', 'Užice', 'Požarevac', 'Pirot', 'Prokuplje', 'Sombor'
  ],
  BA: [
    'Sarajevo', 'Banja Luka', 'Tuzla', 'Zenica', 'Mostar', 'Bijeljina', 'Brčko', 
    'Prijedor', 'Trebinje', 'Doboj', 'Cazin', 'Bihać', 'Livno', 'Travnik', 'Visoko', 
    'Goražde', 'Konjic', 'Jajce', 'Bugojno', 'Sanski Most'
  ]
};

export const PROFESSIONS = [
  'Vodoinstalater',
  'Električar',
  'Soboslikar',
  'Tesar',
  'Zidar',
  'Keramičar',
  'Parketar',
  'Knaufer',
  'Krovopokrivač',
  'Instalater grijanja i klimatizacije',
  'Plinoinstalater',
  'Stolar',
  'Bravar',
  'Staklar',
  'Dimnjačar',
  'Vrtlar',
  'Automehaničar',
  'Autolimar',
  'Serviser bijele tehnike',
  'Serviser klima uređaja',
  'Čistač/ica',
  'Selidbe i prijevoz',
  'Monter namještaja',
  'Fasader',
  'Limar',
  'Građevinski radovi',
  'Adaptacije stanova'
];
